<template>
  <div class="index"  align="center">
<table width="100%" border="0" align="center" cellspacing="0" cellpadding="0">
			<tbody>
				<tr>
					<td valign="top" align="center" class="ssbj">
						<table width="100%" border="0" cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td align="center" height="455">
										<table style="margin-top:40px;" width="80" border="0" cellspacing="0"
											cellpadding="0">
											<tbody>
												<tr>
													<td width="10" style=""></td>
													<td align="center">
														<table width="100%" border="0" cellspacing="0" cellpadding="0">
															<tbody>
																<tr>
																	<td align="left" class="sstt">中国认证信息查询网</td>
																</tr>
																<tr>
																	<td align="left" class="sstta" valign="top">
																		China Certified Information Query System</td>
																</tr>
															</tbody>
														</table>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
								<tr>
									<td align="center">
										<table :width="global.isPhone()?'100%':'60%'" border="0" cellspacing="0" cellpadding="0">
											<tbody>
												<tr>
                          <td align="center" style="padding:0px 0 40px 0;">
                            
                            <el-row>
                              <el-col :span="2" v-if="!global.isPhone()">&nbsp;</el-col>
                              <el-col :span="global.isPhone()?24:20" class='inputt' style="border-radius: 9px;"><div>
                                <el-row>
                                  <el-col :span="12" :class="certType=='person'?'optleft selected':'optleft noselect'"><a href="javascript:;"  @click="handleChangCert('person')"><div class="title-content">新职业技能人才信息查询系统</div></a></el-col>
                                  <el-col :span="12" :class="certType=='company'?'optright selected':'optright noselect'"><a href="javascript:;"  @click="handleChangCert('company')"><div class="title-content">新行业优秀企业信息查询系统</div></a></el-col>
                                </el-row>
                                <el-row>
                                  <el-col :span="24" ><div class="sel-content">{{certType=='person'?'新职业技能人才信息查询系统':'新行业优秀企业信息查询系统'}}</div></el-col>
                                </el-row>
                                <el-row style="margin-top: 40px;margin-bottom: 40px;">
                                <el-col :span="5" v-if="!global.isPhone()">&nbsp;</el-col>
                                <el-col :span="global.isPhone()?16:10">
                                  <el-form label-width="80px" :model="cert">
                                    <el-form-item label=" ">
                                      <el-input v-model="cert.name" :placeholder="certType=='person'?'姓名':'企业名称'" ><i slot="prefix" :class="certType=='person'?'el-input__icon el-icon-user':'el-input__icon el-icon-office-building'"></i></el-input>
                                    </el-form-item>
                                    <el-form-item label=" ">
                                      <el-input v-model="cert.id" :placeholder="certType=='person'?'身份证号':'企业信用代码'"><i slot="prefix" class="el-input__icon el-icon-c-scale-to-original"></i></el-input>
                                    </el-form-item>
                                    <el-form-item label=" ">
                                      <el-input v-model="cert.code" placeholder="证书编号"><i slot="prefix" class="el-input__icon el-icon-postcard"></i></el-input>
                                    </el-form-item>
                                  </el-form>
                                </el-col> 
                                <el-col :span="global.isPhone()?8:4">
                                  <el-button  type="danger" @click="certType=='person'?inqCert():inqCompanyCert()"  size="medium" style="    margin-top: 45px;margin-left: 42px;" round>查询</el-button>
                                </el-col>
                            </el-row>  
                              </div></el-col>
                            </el-row>
                            
                          </td>
                          </tr>
                        
											</tbody>
										</table>
									</td>
								</tr>
                <tr>
                  <td class="certdata">
                    <el-row style="margin-top: 30px;">
                      <el-col :span="global.isPhone()?24:12"><div class="">
                        <el-row>
                          <el-col :span="24" style="">
                            <relitu />
                          </el-col>
                        </el-row>
                      </div></el-col>
                      <el-col :span="12" v-if="!global.isPhone()"><div class=""></div>
                        <el-row>
                          <el-col :span="24">
                            <zhutitu/>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row style="margin-top: 30px;" v-if="global.isPhone()">
                      <el-col :span="24" ><div class=""></div>
                        <el-row>
                          <el-col :span="24">
                            <zhutitu/>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </td>
                </tr>
							</tbody>
						</table>
					</td>
				</tr>
        
				<tr>
					<td style="padding:30px 0 20px 0;" bgcolor="#5789d0" align="center">
						<table width="100%" border="0" cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
									<td align="center" style="line-height:32px;font-size:15px;color:#FFFFFF;">
										中国认证信息查询网<br>
										<br>Copyright &#169; 2022-2023 zgxxw.org.cn Allright
										sreserved. <a onfocus="this.blur();" class="bai" target="_blank"
											href="https://beian.miit.gov.cn/">京ICP备2022033444号-1</a><br>
                      技术支持：<a href="http://www.beijsci.com" style="color:#fff">中国认证信息查询网</a>
										<table>
											<tbody>
												<tr></tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
    <el-dialog title="请选择职业名称" :width="global.isPhone()?'90%':'25%'" top="25vh" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="职业名称" :label-width="formLabelWidth">
        <el-select v-model="form.code" placeholder="请选择职业名称">
          <el-option v-for="(cet,index) in certs" :key="index" :label="certType=='person'?cet.position:cet.professionaltitle" :value="cet.code"></el-option>
        </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="toResultPage()">确 定</el-button>
      </div>
      </el-dialog>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import Relitu from "../components/PublicComs/relitu.vue";
import Zhutitu from "../components/PublicComs/zhutitu.vue";
import { Message } from "element-ui";
export default {
  name: "index",
  components: {
    Relitu,
    Zhutitu,
  },
  data() {
    return {
      certType: "person",
      formLabelAlign: {},
      dialogFormVisible: false,
      formLabelWidth: "120px",
      certs: [],
      cert: {
        name: "",
        code: "",
        id: "",
      },
      form: {
        code: "",
      },
      global,
    };
  },
  mounted() {
    let id = this.$route.params.id;
    if (id == "inqcompany") {
      this.handleChangCert("company");
    }
    window.addEventListener("keydown", this.keyDown);
  },
  methods: {
    handleChangCert(certType) {
      this.certType = certType;
      console.log(certType);
    },
    inqCert() {
      let url = "/api/certificates/userget?";

      if (this.cert.name) url += `name=${this.cert.name.trim()}`;
      else {
        Message.error("请输入姓名！");
        return;
      }
      if (this.cert.id) url += `&cardtid=${this.cert.id.trim()}`;
      if (this.cert.code) url += `&code=${this.cert.code.trim()}`;

      this.$axios.get(encodeURI(url)).then((res) => {
        if (res.data.success == true && res.data.data.length > 0) {
          if (res.data.data.length > 1) {
            this.certs = res.data.data;
            this.dialogFormVisible = true;
          } else {
            return this.$router.replace(
              encodeURI(
                `/certResult/?name=${this.cert.name.trim()}&code=${
                  res.data.data[0].code
                }&type=${this.certType}`
              )
            );
          }
        } else {
          return Message.error("无法查询到此证书，请确认信息是否填写正确！");
        }
      });
    },
    inqCompanyCert() {
      let url = "/api/companyCertificates/userget?";
      if (this.cert.name) url += `companyname=${this.cert.name.trim()}`;
      else {
        Message.error("请输入企业名称！");
        return;
      }
      if (this.cert.id) url += `&socilacredit=${this.cert.id.trim()}`;
      if (this.cert.code) url += `&code=${this.cert.code.trim()}`;
      this.$axios.get(encodeURI(url)).then((res) => {
        if (res.data.success == true && res.data.data.length > 0) {
          if (res.data.data.length > 1) {
            this.certs = res.data.data;
            this.dialogFormVisible = true;
          } else {
            return this.$router.replace(
              encodeURI(
                `/comCertResult/?name=${this.cert.name.trim()}&code=${res.data.data[0].code.trim()}&type=${
                  this.certType
                }`
              )
            );
          }
        } else {
          return Message.error("无法查询到此证书，请确认信息是否填写正确！");
        }
      });
    },
    toResultPage() {
      this.cert.code = this.form.code;
      if (this.certType == "company") {
        return this.$router.replace(
          `/comCertResult/?name=${this.cert.name.trim()}&code=${this.cert.code.trim()}&type=${
            this.certType
          }`
        );
      }
      return this.$router.replace(
        `/certResult/?name=${this.cert.name.trim()}&code=${this.cert.code.trim()}&type=${
          this.certType
        }`
      );
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.inqCert();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>
<style scoped>
.el-row {
  margin-bottom: 20px;
}
.title-content {
  font-size: 27px;
  margin: 13px 13px;
  color: #fff;
}
@media screen and (max-width: 767px) {
  .title-content {
    font-size: 25px;
    margin: 10px 10px;
    color: #fff;
  }
}
.selected {
  background-color: #3664a7;
}
.optright {
  /* border-radius: 4px; */
  border-top-left-radius: 0px;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 0px;
}
.noselect {
  background-color: #78a1d9;
}
.optleft {
  /* border-radius: 4px; */
  border-top-left-radius: 9px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 9px;
}
.sel-content {
  font-size: 30px;
  margin: 13px 13px;
  color: #fff;
}
.title-data {
  font-size: 27px;
  margin: 13px 13px;
  text-align: center;
}
.inputt {
  background-color: #6390d0;
}
.inputt .el-button {
  font-weight: 900;
  line-height: 2;
  width: 150px;
}
.inputt .el-button--medium {
  font-size: 26px;
}
/deep/ .inputt .el-button--danger:hover {
  background: #da251c;
  border-color: #da251c;
  color: #fff;
}
/deep/ .inputt .el-button--danger {
  background: #ec3933;
  border-color: #da251c;
  color: #fff;
}
/deep/ .inputt .el-button.is-round {
  border-radius: 25px;
  padding: 12px 23px;
}
.el-button--medium {
  font-size: 18px;
}
.certdata {
  background-color: #e9e9e9;
}
</style>
